import { render, staticRenderFns } from "./SvgHomePointsPicto2.vue?vue&type=template&id=0bd67bbe&scoped=true"
import script from "./SvgHomePointsPicto2.vue?vue&type=script&lang=js"
export * from "./SvgHomePointsPicto2.vue?vue&type=script&lang=js"
import style0 from "./SvgHomePointsPicto2.vue?vue&type=style&index=0&id=0bd67bbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd67bbe",
  null
  
)

export default component.exports